import { render, staticRenderFns } from "./ProfileEditView.vue?vue&type=template&id=5b31f22b&"
import script from "./ProfileEditView.vue?vue&type=script&lang=ts&"
export * from "./ProfileEditView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports